import React from "react";

import { Grid, Typography } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

const SKELETON_ROW_COUNT = 8;

const renderSkeletonRows = (columnCount = 0, rowCount = SKELETON_ROW_COUNT) =>
  Array.from({ length: rowCount }, (_, rowIndex) => (
    <tr key={`skeleton-row-${rowIndex}`}>
      {Array.from({ length: columnCount }, (_, columnIndex) => (
        <td className="py-1" key={`skeleton-cell-${columnIndex}`}>
          <Skeleton height={30} animation="pulse" />
        </td>
      ))}
    </tr>
  ));

const GenericTable = ({
  tableColumns = [],
  tableData = [],
  total = 0,
  isLoading,
  onClickRow,
}) => {
  const columns = Array.isArray(tableColumns) ? tableColumns : [];
  const rows = Array.isArray(tableData) ? tableData : [];

  const hasRows = rows.length > 0;
  const resultCountText = `${rows.length} results shown out of ${total} total`;

  const handleClickRow = (row) => {
    if (typeof onClickRow === "function") {
      onClickRow(row);
    }
  };

  return (
    <Grid container direction="column" className="gap-y-8">
      <Typography variant="caption">
        {isLoading ? "Getting Results..." : hasRows ? resultCountText : ""}
      </Typography>

      <table className="table table-hover generic-table-wrapper">
        <thead>
          <tr className="font-normal">
            {columns.map(({ id, label }, index) => (
              <th key={id ?? index}>{label ?? ""}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {isLoading ? (
            renderSkeletonRows(columns.length)
          ) : hasRows ? (
            rows.map((row, rowIndex) => (
              <tr
                key={rowIndex}
                className="cursor-pointer"
                onClick={() => handleClickRow(row)}
              >
                {columns.map(({ id }, columnIndex) => (
                  <td key={id ?? columnIndex}>{row?.[id] ?? ""}</td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={columns.length}>No Results</td>
            </tr>
          )}
        </tbody>
      </table>
    </Grid>
  );
};

export default GenericTable;
